import { useEffect, useRef, useState, useMemo } from 'react';
import Accordion from '../../components/common/Accordian';
import PilotForm from '../../components/common/PilotForm';
import SunIcon from '../../assets/SunIcon';
import AddFormIcon from '../../assets/AddFormIcon';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import EditIcon from '../../assets/EditIcon';
import ReusableSelect from '../../components/common/Select';
import CrewPilotDetailsCard from '../../components/common/CrewPiolotCard';
import operationAPI from '../../api/operationApi';
import { IOperations } from '../../type/operation';
import GoogleMapComponent from '../../components/ui/GoogleMapSection';
import { ILocation } from '../../type/location';
import { ITemperature } from '../../type/temperature';
import { IDutyManager } from '../../type/dutyManager';
import ListView from '../../components/common/ListViewComponent';
import useLocationStore from '../../store/locatonStore';
import {
  DateSelector,
  CountryPaxSection,
  FlightSections,
} from '../../components';
import PdDownHill from '../../components/common/PdDownHill';
import Allocations from '../../components/common/Allocations';
import { toast } from 'react-toastify';
import { locationConstant, StaffConstant } from '../../constants/constant';
import { IDutyManagerRequest } from '../../type/addDutyManager';
import { IAddTemperatureRequest } from '../../type/addTemp';
import CheckIcon from '../../assets/CheckIcon';
import { IStaffAllocation } from '../../type/staffAllocation';
import useTemperatureStore from '../../store/temperatureStore';
import {
  encodeDateForUrl,
  formatStartTime,
  getAdjustedDate,
} from '../../utils/dateUtils';
import { translate } from '../../i18n';
import useDateStore from '../../store/selectedDateStore';
import useDebounce from '../../hooks/useDebounce';
import GoogleDriveIcon from '../../assets/GoogleDriveIcon';
import ReusableSelectLocation from '../../components/common/SelectLocation';
import BreakFast from '../../components/common/BreakFast';
import PaymentBreakup from '../../components/common/PaymentBreakup';
import useBgColorStore from '../../store/bgColor';
import CalendarHeader from '../../components/common/Header/CalenderHeader';
import EditFormFlight from '../../components/common/EditFormFlight';
import { IFlightDetails } from '../../type/flightDetails';
import WeatherAndTravelStatus from '../../components/ui/WeatherAndTravel';
import GoogleDriveIconDark from '../../assets/GoogleDriveIconDark';
import SunIconDark from '../../assets/SunIconDark';
import CheckIconDark from '../../assets/CheckIconDark';
import EditIconDark from '../../assets/EditIconDark';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import AddFormIconDark from '../../assets/AddFormIconDark';
import GeneralComment from '../../components/common/GeneralComment';
import { showOrReplaceToast } from '../../utils/utility';
import Loader from '../../assets/loader/Loader';
import OperationCheckListComponent from '../../components/common/OperationCheckList';
import DriverComponent from '../../components/common/DriverComponent';
import CrewComponent from '../../components/common/CrewComponent';
import {
  useOperationDetails,
  useOwnerLocations,
  usePilotAllocation,
  useTemperatureList,
  useTodayTemperature,
} from '../../hooks/apiHook/operationDetails';
import { IUpdateResPhone } from '../../type/addRes';

type ModalType =
  | 'CrewForm'
  | 'DriverForm'
  | 'PilotForm'
  | 'EditFormFlight'
  | 'GeneralComment'
  | null;

const DesktopOperations = () => {
  const { bgColor, updateBgColor } = useBgColorStore();
  const { setSelectedDateFromStore } = useDateStore();
  const selectedDateFromStore = useDateStore(
    (state) => state.selectedDateFromStore,
  );

  const [apiResponse, setApiResponse] = useState<IOperations>();
  const [staffAllocation, setStaffAllocation] = useState<IStaffAllocation[]>();
  const [locationList, setLocationList] = useState<ILocation[]>();
  const [googleDriverLink, setGoogleDriverLink] = useState('');
  const [ofl, setOfl] = useState<string | null>(null);
  const [initialOfl, setInitialOfl] = useState('');
  const [operationStaffId, setOperationStaffId] = useState<number>();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const setSelectedLocation = useLocationStore(
    (state) => state.setSelectedLocation,
  );
  const [selectedLocationId, setSelectedLocationId] = useState<number>(
    selectedLocation?.OwnerId || locationConstant.ownerId,
  );

  const [selectedDate, setSelectedDate] = useState<Date>(
    selectedDateFromStore || getAdjustedDate(),
  );

  useEffect(() => {
    setSelectedDate(selectedDateFromStore);
  }, [selectedDateFromStore]);

  const [editingBookingId, setEditingBookingId] = useState<number | null>(null);
  const [flightDetail, setFlightDetail] = useState<IFlightDetails>();
  const [reloadKey, setReloadKey] = useState(0);
  const [crewDetails, setCrewDetails] = useState<IStaffAllocation | null>(null);

  const isFirstRender = useRef(true);
  const [selectedDutyManager, setSelectedDutyManager] = useState<
    number | undefined
  >(undefined);
  const [selectedPic, setSelectedPic] = useState<number | undefined>(undefined);
  const [selectedRes, setSelectedRes] = useState<number | undefined>();
  const [dutyManagerOperationStaffId, setDutyManagerOperationStaffId] =
    useState<number>();
  const [modalCallback, setModalCallback] = useState<(() => void) | undefined>(
    undefined,
  );
  const [resOperationStaffId, setResOperationStaffId] = useState<number>();
  const [picOperationStaffId, setPicOperationStaffId] = useState<number>();
  const [refreshCalender, setRefreshCalender] = useState(0);

  const debouncedOfl = useDebounce(ofl, 1500);

  const [pilotAccordionIsOpen, setPilotAccordionIsOpen] = useState<
    boolean | undefined
  >(false);
  const { setSelectedTemperature } = useTemperatureStore();
  const [temp, setTemp] = useState<number>();

  const [isEditing, setIsEditing] = useState(false);

  // Memoize encoded date
  const encodedDate = useMemo(
    () => encodeDateForUrl(selectedDate),
    [selectedDate],
  ); // Only run when location or fetchData changes
  const {
    data: operationDetailsData,
    isLoading,
    isFetching,
    refetch,
  } = useOperationDetails(selectedLocation.OwnerId, encodedDate);
  useEffect(() => {
    if (operationDetailsData) {
      setApiResponse(operationDetailsData);
    }
  }, [operationDetailsData]);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (selectedLocation?.OwnerId || selectedDate) {
      refetch();
    }
  }, [selectedLocation.OwnerId, selectedDate, selectedDateFromStore]);

  useEffect(() => {
    if (apiResponse?.staffAllocationOfTheDay) {
      setSelectedDutyManager(
        apiResponse.staffAllocationOfTheDay.dutyManagerStaffId || undefined,
      );
      setDutyManagerOperationStaffId(
        apiResponse.staffAllocationOfTheDay.operationStaffIdDutyManager,
      );
      setSelectedPic(
        apiResponse.staffAllocationOfTheDay.picStaffId || undefined,
      );
      setPicOperationStaffId(
        apiResponse?.staffAllocationOfTheDay.picOperationStaffId,
      );
      setSelectedRes(apiResponse?.resCandidateStaffId || undefined);
      setResOperationStaffId(
        apiResponse?.staffAllocationOfTheDay?.resOperationStaffId,
      );
    }
  }, [apiResponse]);

  useEffect(() => {
    if (apiResponse?.googleDriverLink) {
      setGoogleDriverLink(apiResponse.googleDriverLink ?? '');
    } else {
      setGoogleDriverLink('');
    }
    const ofl = apiResponse?.ofl
      ? new Date(apiResponse?.ofl).toISOString().substring(11, 16)
      : '';
    setInitialOfl(ofl);
  }, [apiResponse, selectedLocation, reloadKey, selectedDate]);

  useEffect(() => {
    if (selectedLocation) {
      setSelectedLocationId(selectedLocation.OwnerId);
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (debouncedOfl) {
      console.log('API called with value:', debouncedOfl);
      handlerAddOfl(debouncedOfl);
    }
  }, [debouncedOfl]);

  const addResHandler = async (data: IUpdateResPhone) => {
    try {
      await operationAPI.addRes(data);
      showOrReplaceToast(
        'operations',
        translate('operation.staffAddedSuccessfully'),
        'success',
      );
    } catch (error) {
      showOrReplaceToast(
        'operations',
        translate('operation.commonError'),
        'error',
      );
    }
  };

  const addDutyManagerHandler = async (
    staffId: number,
    ownerId: number,
    date: string,
    roleId: number,
    operationStaffId?: number,
  ) => {
    try {
      const data: IDutyManagerRequest = {
        staffId,
        ownerId,
        date,
        roleId: roleId,
        operationStaffId: operationStaffId,
      };
      const responses = await operationAPI.addDutyManager(data);
      console.log(responses);
      showOrReplaceToast(
        'operations',
        translate('operation.staffAddedSuccessfully'),
        'success',
      );
    } catch (error) {
      console.log(error);
      toast.warn(translate('operation.commonError'));
    }
  };

  const handleLocationChange = (selectedOption: ILocation | null) => {
    if (selectedOption) {
      setSelectedLocationId(selectedOption.OwnerId);
      setSelectedLocation(selectedOption);
      updateBgColor();
    }
  };

  const {
    data: pilotData,
    isLoading: isPilotLoading,
    isFetching: isPilotFetching,
    refetch: refetchPilotAllocation,
  } = usePilotAllocation(selectedLocation.OwnerId, selectedDate);

  useEffect(() => {
    if (pilotData) {
      setStaffAllocation(pilotData);
    }
  }, [pilotData]);

  const {
    data: ownerLocationsData,
    isLoading: isOwnerQueryLoading,
    isFetching: isOwnerQueryFetching,
  } = useOwnerLocations();

  // Set local state when data arrives
  useEffect(() => {
    if (ownerLocationsData) {
      setLocationList(ownerLocationsData);
    }
  }, [ownerLocationsData]);

  const googleDriverLinkSubmitHandler = async (link: string) => {
    try {
      const encodedDate = encodeDateForUrl(selectedDate);
      await operationAPI.googleDriverImage(
        encodedDate,
        link,
        selectedLocation.OwnerId,
      );
      showOrReplaceToast(
        'operations',
        translate('operation.googleDriverAdded'),
        'success',
      );
      setIsEditable(false);
    } catch (error) {
      console.log(error);
      toast.warn(translate('operation.commonError'));
    }
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
      setSelectedDateFromStore(date);
    }
  };

  const openModal = (modalType: ModalType, staff?: IStaffAllocation) => {
    setActiveModal(modalType);
    setCrewDetails(staff ?? null);
  };

  const openModalFlight = (
    modalType: ModalType,
    flightDetail?: IFlightDetails,
    callback?: () => void,
  ) => {
    setActiveModal(modalType);
    setFlightDetail(flightDetail);
    setModalCallback(() => callback);
  };

  const closeModal = () => setActiveModal(null);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  const handleOperationStaffIdChange = (operationStaffId: number) => {
    setOperationStaffId(operationStaffId);
  };

  const handleStaffChange = (type: 'driver' | 'pilot' | 'crew' | 'booking') => {
    if (type === 'pilot') {
      // setPilotLoading(true);
      setPilotAccordionIsOpen(true);
      refetchPilotAllocation();
      refetch();
    }
  };

  const addTemperature = async (data: IAddTemperatureRequest) => {
    try {
      await operationAPI.addTemperature(data);
      showOrReplaceToast(
        'operations',
        translate('operation.tempAddedSuccessfully'),
        'success',
      );
      refetchTodayTemp();
    } catch (error) {
      toast.warn(translate('operation.commonError'));
    }
  };

  const handleEditToggle = () => setIsEditing((prev) => !prev);

  const handleDutyManagerChange = (selectedValue: IDutyManager) => {
    const encodedDate = encodeDateForUrl(selectedDate);
    setSelectedDutyManager(selectedValue.staffId);
    setRefreshCalender((r) => r + 1);
    setPhoneNumber(selectedValue.staffContact);
    if (dutyManagerOperationStaffId) {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.DUTY_MANAGER,
        dutyManagerOperationStaffId,
      );
    } else {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.DUTY_MANAGER,
      );
    }
  };

  const handleDutyPicChange = (selectedValue: IDutyManager) => {
    const encodedDate = encodeDateForUrl(selectedDate);
    setSelectedPic(selectedValue.staffId);
    setRefreshCalender((r) => r + 1);
    setPhoneNumber(selectedValue.staffContact);
    if (picOperationStaffId) {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.PIC,
        picOperationStaffId,
      );
    } else {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.PIC,
      );
    }
  };
  const handleResChange = (selectedValue: IDutyManager) => {
    const encodedDate = encodeDateForUrl(selectedDate);
    setSelectedRes(selectedValue.staffId);
    setRefreshCalender((r) => r + 1);
    setPhoneNumber(selectedValue.staffContact);
    const data: IUpdateResPhone = {
      resPhone: selectedValue.staffName + selectedValue.staffContact,
      date: encodedDate,
      ownerId: selectedLocation.OwnerId,
    };
    addResHandler(data);
  };

  const handleEditClick = (bookingId: number | null) => {
    if (bookingId === null) {
      setEditingBookingId(null);
    } else {
      setEditingBookingId(bookingId);
    }
  };

  const handlerAddOfl = async (time: string) => {
    try {
      await operationAPI.addOfl({
        toDate: encodeDateForUrl(selectedDate),
        oflTime: await formatStartTime(time),
        ownerId: selectedLocation.OwnerId,
      });
      showOrReplaceToast(
        'operations',
        translate('ofl.oflSuccessMessage'),
        'success',
      );
    } catch (error) {
      console.log(error);
      toast.warn(translate('operation.commonError'));
    }
  };
  const [tempList, setTempList] = useState<ITemperature[]>([]);
  const [todayTemp, setTodayTemp] = useState<number>();
  const { data: temperatureList } = useTemperatureList();

  useEffect(() => {
    if (temperatureList) {
      setTempList(temperatureList);
    }
  }, [temperatureList]);

  const {
    data: todayTemperature,
    isLoading: todayTempIsLoading,
    isFetching: todayTempIsFetching,
    refetch: refetchTodayTemp,
  } = useTodayTemperature(selectedLocation?.OwnerId, encodedDate);

  const [todaysTemp, setTodaysTemp] = useState<number>();

  useEffect(() => {
    if (todayTemperature) {
      setTodayTemp(todayTemperature.temperatureid1);
      setTodaysTemp(todayTemperature.temperature1);
      setTemp(todayTemperature.temperatureid1);
    }
  }, [todayTemperature]);

  useEffect(() => {
    refetchTodayTemp();
  }, []);

  useEffect(() => {
    refetchTodayTemp();
  }, [selectedLocation?.OwnerId, selectedDate]);

  return (
    <div style={{ textAlign: 'center' }}>
      <div className="bg-background">
        <div className="">
          <CalendarHeader refreshCalender={refreshCalender} />
        </div>
        <div className="pl-4">
          <div className="text-start">
            <h1 className={`text-lg font-semibold text-text-blue `}>
              {translate('operation.dailyOperation')}
            </h1>
          </div>
          <div className={` rounded-lg flex  justify-between pt-4 pb-4`}>
            <div className="flex justify-between w-[100%] ">
              <div className="text-start mr-4 w-[30%]">
                <label className="text-text-primary">
                  {translate('common.location')}
                </label>
                <>
                  {isOwnerQueryLoading || isOwnerQueryFetching ? (
                    <div className="w-full flex justify-center items-center py-4">
                      <Loader />{' '}
                    </div>
                  ) : (
                    <ReusableSelectLocation<ILocation>
                      options={locationList || ([] as ILocation[])}
                      className="w-full border border-customBorder-border rounded p-2 text-sm bg-sidebar-background text-text-primary"
                      getOptionLabel={(option: ILocation) =>
                        option.locationName
                      }
                      getOptionValue={(option: ILocation) => option.OwnerId}
                      onChange={handleLocationChange}
                      placeholder="Select a location"
                      value={selectedLocationId}
                    />
                  )}
                </>
              </div>
              <div className="text-start mr-4 w-[20%]">
                <label className="text-text-primary">
                  {translate('common.date')}
                </label>
                <div className="flex items-center h-[38px] p-2 rounded border border-customBorder-border  bg-sidebar-background ">
                  <DateSelector
                    onDateChange={handleDateChange}
                    initialDate={selectedDate}
                    showArrows={true}
                  />
                </div>
              </div>

              <div className="text-start mr-4 w-[8%] ">
                <label className="text-text-primary ml-2">
                  {translate('operation.loadTemp')}
                </label>
                <div
                  className={`ml-2 flex items-center space-x-1 rounded w-full gap-1 h-[38px] border-t border-customBorder-border border`}
                >
                  <span>
                    <div>
                      <div className="block dark:hidden">
                        <SunIcon />
                      </div>
                      <div className="hidden dark:block">
                        <SunIconDark />
                      </div>
                    </div>
                  </span>
                  {todayTempIsLoading || todayTempIsFetching ? (
                    <Loader />
                  ) : (
                    <p className="text-text-primary">{todaysTemp}°C</p>
                  )}
                </div>
              </div>

              <div className="text-start  w-[10%]">
                <div>
                  <div className="text-start mr-4">
                    <label className="text-text-primary">
                      {translate('ofl.ofl')}
                    </label>
                    <div className="flex items-center h-[38px]">
                      {isLoading || isFetching ? (
                        <>
                          <Loader />
                        </>
                      ) : (
                        <input
                          type="time"
                          min="00:00"
                          max="11:59"
                          step={60}
                          placeholder={translate('driver.startTimePlaceholder')}
                          value={ofl || initialOfl}
                          className="block w-full p-1 border border-customBorder-border rounded-md hide-ampm ofltime  bg-sidebar-background text-text-primary"
                          onChange={(e) => {
                            setOfl(e.target.value);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-start  w-[36%]">
                <div
                  className={`w-full flex flex-col items-start rounded  mb-4 h-[60px] px-4 `}
                >
                  <p className={`text-text-primary w-[50px]  `}>
                    {translate('operation.photos')}
                  </p>
                  <div
                    className={`flex items-center rounded h-[60px] px-1 py-1 w-full ${bgColor}`}
                  >
                    <div className=" relative w-full  ml-6 ">
                      <input
                        type="text"
                        placeholder="Google Drive Link"
                        className={`w-full  pl-10 pr-3 py-2 border border-customBorder-border rounded text-sm ${bgColor} text-text-primary placeholder:text-text-primary  bg-sidebar-background `}
                        onChange={(e) => setGoogleDriverLink(e.target.value)}
                        value={googleDriverLink ?? ''}
                        disabled={!isEditable}
                      />
                      <div className="absolute left-3 top-1/2 transform -translate-y-1/2 ">
                        <div>
                          <div className="block dark:hidden">
                            <GoogleDriveIcon />
                          </div>
                          <div className="hidden dark:block">
                            <GoogleDriveIconDark />
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      className="text-blue-500 hover:text-blue-700 mr-4 ml-4"
                      onClick={() => {
                        if (isEditable) {
                          googleDriverLinkSubmitHandler(googleDriverLink);
                        } else {
                          setIsEditable(true);
                        }
                      }}
                    >
                      {isEditable ? (
                        <div>
                          <div className="block dark:hidden">
                            <CheckIcon />
                          </div>
                          <div className="hidden dark:block">
                            <CheckIconDark />
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="block dark:hidden">
                            <EditIcon />
                          </div>
                          <div className="hidden dark:block">
                            <EditIconDark />
                          </div>
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex w-full h-full gap-3">
            <div className="flex flex-col w-1/2 gap-3">
              <div className={` rounded  ${bgColor}`}>
                <Accordion
                  title={translate('operation.allAllocation')}
                  bgColor={`${bgColor}`}
                  iconOpen={
                    <div>
                      <div className="block dark:hidden">
                        <AccordianDownIcon />
                      </div>
                      <div className="hidden dark:block">
                        <AccordianDownIconDark />
                      </div>
                    </div>
                  }
                  iconClose={
                    <div>
                      <div className="block dark:hidden">
                        <AccordianUpIcon />
                      </div>
                      <div className="hidden dark:block">
                        <AccordianUpIconDark />
                      </div>
                    </div>
                  }
                >
                  {isLoading ? (
                    <div className="flex justify-center align-middle">
                      <Loader />
                    </div>
                  ) : (
                    <>
                      <div className="space-y-4 mx-auto mb-4">
                        {/* Duty Manager */}
                        <div className="flex w-full">
                          <p className="w-[30%] text-left text-textColorGray font-medium text-sm">
                            {translate('operation.dutyManager')}
                            {' ' + `${apiResponse?.dutyManagerPhoneNumber}`}
                          </p>
                          <div className=" flex items-center space-x-2 w-[70%]">
                            <ReusableSelect<IDutyManager>
                              options={apiResponse?.dutyManager || []}
                              // text-text-whiteBlackColor
                              className={`w-full border border-customBorder-border rounded p-2 text-sm bg-backgroundColor-darkThemeColor text-text-secondary `}
                              getOptionLabel={(option) =>
                                `${option.staffName + ' ' + option.staffContact}`
                              }
                              getOptionValue={(option) => option.staffId}
                              onChange={handleDutyManagerChange}
                              placeholder="Select Duty Manager"
                              value={selectedDutyManager}
                            />
                          </div>
                        </div>

                        {/* Pilot in Command */}
                        <div className="flex w-full">
                          <p className="w-[30%] text-left text-textColorGray font-medium text-sm">
                            {translate('operation.pilotInCommand')}
                          </p>
                          <div className=" flex items-center space-x-2 w-[70%]">
                            <ReusableSelect<IDutyManager>
                              options={apiResponse?.picManager || []}
                              className={`w-full border border-customBorder-border rounded p-2 text-sm bg-backgroundColor-darkThemeColor text-text-secondary`}
                              getOptionLabel={(option) =>
                                `${option.staffName + ' ' + option.staffContact}`
                              }
                              getOptionValue={(option) => option.staffId}
                              onChange={handleDutyPicChange}
                              placeholder="Select Pilot In Command"
                              value={selectedPic}
                            />
                          </div>
                        </div>

                        {/* Reservation */}
                        <div className="flex w-full">
                          <p className="w-[30%] text-left text-textColorGray font-medium text-sm">
                            {translate('operation.reservation')}
                          </p>
                          <div className="flex items-center space-x-2 w-[70%]">
                            <ReusableSelect<IDutyManager>
                              options={apiResponse?.resAvailableList || []}
                              className={`w-[100%] border border-customBorder-border rounded p-2 text-sm bg-backgroundColor-darkThemeColor text-text-secondary`}
                              getOptionLabel={(option) =>
                                `${option.staffName + ' ' + option.staffContact}`
                              }
                              getOptionValue={(option: IDutyManager) =>
                                option.staffId
                              }
                              onChange={handleResChange}
                              placeholder="Select Res"
                              value={selectedRes}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </Accordion>
              </div>

              <div className={`${bgColor} w-full  rounded`}>
                <CountryPaxSection
                  selectedDate={selectedDate}
                  ownerId={selectedLocation.OwnerId}
                />
              </div>

              <div className={`rounded ${bgColor}`}>
                <Accordion
                  key={1}
                  title={'Map'}
                  // icon={<EditIcon style={{ cursor: 'pointer' }} />}
                  bgColor={`${bgColor}`}
                  onToggleEditMode={handleEditClick}
                  iconOpen={
                    <div>
                      <div className="block dark:hidden">
                        <AccordianDownIcon />
                      </div>
                      <div className="hidden dark:block">
                        <AccordianDownIconDark />
                      </div>
                    </div>
                  }
                  iconClose={
                    <div>
                      <div className="block dark:hidden">
                        <AccordianUpIcon />
                      </div>
                      <div className="hidden dark:block">
                        <AccordianUpIconDark />
                      </div>
                    </div>
                  }
                >
                  <div
                    className={`${bgColor} rounded-lg grid grid-cols-2 gap-2 mt-2`}
                  >
                    {!isLoading ? (
                      <>
                        {apiResponse?.maxForUpDownHillForPdAndCairns?.map(
                          (route, index) => (
                            <PdDownHill
                              key={index}
                              title={route?.transferRouteName}
                              data={[
                                {
                                  label: 'Pickup Max',
                                  current: route?.busPickupCurrent,
                                  max: route?.busPickupMax,
                                },
                                {
                                  label: 'Drop off Max',
                                  current: route?.dropoffCurrent,
                                  max: route?.dropoffMax,
                                },
                              ]}
                            />
                          ),
                        )}

                        <Allocations
                          title="Allocations"
                          data={
                            apiResponse?.busFlightPaxAllocation || undefined
                          }
                        />
                      </>
                    ) : (
                      <Loader />
                    )}
                  </div>

                  <div className={`relative  h-80 rounded mt-2 ${bgColor}`}>
                    <GoogleMapComponent date={selectedDate} />
                  </div>
                  <div className="mt-4">
                    <Accordion
                      key={1}
                      title={'List View'}
                      iconOpen={
                        <div>
                          <div className="block dark:hidden">
                            <AccordianDownIcon />
                          </div>
                          <div className="hidden dark:block">
                            <AccordianDownIconDark />
                          </div>
                        </div>
                      }
                      iconClose={
                        <div>
                          <div className="block dark:hidden">
                            <AccordianUpIcon />
                          </div>
                          <div className="hidden dark:block">
                            <AccordianUpIconDark />
                          </div>
                        </div>
                      }
                      bgColor={`bg-backgroundColor-darkThemeColor`}
                    >
                      <div className={`relative   rounded`}>
                        <ListView data={[]} date={selectedDate} />
                      </div>
                    </Accordion>
                  </div>
                </Accordion>
              </div>

              <div className={`relative ${bgColor} rounded`}>
                <PaymentBreakup
                  title="Payment Breakup"
                  operationDate={selectedDate}
                  ownerId={selectedLocation?.OwnerId}
                  showHeading={true}
                />
              </div>
              <div className={`relative ${bgColor} rounded`}>
                <BreakFast
                  selectedDate={encodeDateForUrl(selectedDate)}
                  ownerId={selectedLocation?.OwnerId}
                  showHeading={true}
                />
              </div>
            </div>
            <div className="flex flex-col w-1/2 ">
              <div>
                <FlightSections
                  selectedDate={selectedDate}
                  ownerId={selectedLocation.OwnerId}
                  openModal={openModalFlight}
                  closeModal={closeModal}
                  onPilotChangeRefetchTrigger={isPilotFetching}
                />
              </div>
              {activeModal === 'EditFormFlight' && flightDetail && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50 p-2">
                  <EditFormFlight
                    title="Edit Flight"
                    balloonName={flightDetail?.formattedBalloonName}
                    capacity={flightDetail?.maxPax}
                    allocatedPax={flightDetail?.allocatedPax}
                    launchTime={`${flightDetail.balloonTakeoffTime}`}
                    landTime={`${flightDetail?.balloonLandTime}`}
                    fuel={flightDetail?.fuelUsed}
                    closeModal={closeModal}
                    onConfirm={(data) => console.log('Form Submitted:', data)}
                    operationId={flightDetail?.operationId}
                    operationBalloonId={flightDetail?.operationBalloonId}
                    onAfterSubmit={modalCallback}
                  />
                </div>
              )}
              <DriverComponent
                routes={apiResponse?.routeList || []}
                buses={apiResponse?.busList || []}
                balloons={apiResponse?.balloonList || []}
                date={selectedDate}
              />

              {/* Pilot Allocation */}
              <Accordion
                title="Pilot Allocation"
                iconOpen={
                  <div>
                    <div className="block dark:hidden">
                      <AccordianDownIcon />
                    </div>
                    <div className="hidden dark:block">
                      <AccordianDownIconDark />
                    </div>
                  </div>
                }
                iconClose={
                  <div>
                    <div className="block dark:hidden">
                      <AccordianUpIcon />
                    </div>
                    <div className="hidden dark:block">
                      <AccordianUpIconDark />
                    </div>
                  </div>
                }
                icon={
                  <div>
                    <div className="block dark:hidden">
                      <AddFormIcon />
                    </div>
                    <div className="hidden dark:block">
                      <AddFormIconDark />
                    </div>
                  </div>
                }
                accordionIsOpen={pilotAccordionIsOpen}
                toggleState={setPilotAccordionIsOpen}
                formComponent={
                  <PilotForm
                    heading="Add Pilot"
                    closeModal={closeModal}
                    balloons={apiResponse?.balloonList || []}
                    crewVehicleList={apiResponse?.crewVehicleList || []}
                    onStaffChange={() => handleStaffChange('pilot')}
                    staffAllocation={staffAllocation || null}
                    date={selectedDate}
                  />
                }
                bgColor={`${bgColor}`}
              >
                {isLoading || isFetching ? (
                  <div className="flex justify-center align-middle">
                    <Loader />
                  </div>
                ) : (
                  <div
                    className={`bg-backgroundColor-darkThemeColor space-y-4 mb-4`}
                  >
                    <div className="grid grid-cols-3 gap-4">
                      <div className="flex gap-4 items-center flex-col">
                        <label className="block text-textColorGray text-sm font-medium mb-1">
                          {translate('operation.total')}
                        </label>
                        <input
                          type="text"
                          className={`focus:outline-none focus:ring-0 focus:border-customBorder-border w-full border border-customBorder-border rounded p-2 text-sm bg-backgroundColor-darkThemeColor text-center text-textColorGray`}
                          value={apiResponse?.totalMaxPax?.totalMaxPax ?? ''}
                          readOnly
                        />
                      </div>

                      {/* Flight Field */}
                      <div className="flex gap-4 items-center flex-col">
                        <label className="block  text-textColorGray text-sm font-medium mb-1  ">
                          {translate('operation.flight')}
                        </label>
                        <input
                          type="text"
                          className={`focus:outline-none focus:ring-0 focus:border-customBorder-border w-full border border-customBorder-border rounded p-2 text-sm bg-backgroundColor-darkThemeColor text-center text-textColorGray`}
                          value={apiResponse?.totalMaxPax?.totalAllocCount}
                          readOnly
                        />
                      </div>

                      <div className="flex gap-4 items-center flex-col">
                        <label className="block text-textColorGray text-sm font-medium mb-1">
                          {translate('operation.balloonCount')}
                        </label>
                        <input
                          type="text"
                          className={`focus:outline-none focus:ring-0 focus:border-customBorder-border w-full border border-customBorder-border rounded p-2 text-sm bg-backgroundColor-darkThemeColor text-center text-textColorGray`}
                          value={apiResponse?.totalMaxPax?.totalBalloons}
                          readOnly
                        />
                      </div>
                    </div>

                    {/* Flight Requirements Section */}
                    <div
                      className={`bg-backgroundColor-darkThemeColor p-4 rounded`}
                    >
                      {/* Header */}
                      <div className="flex justify-between items-center mb-4">
                        <h2 className="text-textColor font-semibold text-sm">
                          {translate('operation.flightRequirements')}
                        </h2>
                        <button
                          onClick={handleEditToggle}
                          className="text-textColor hover:text-textColor"
                        >
                          {/* Edit Icon */}
                          <div>
                            <div className="block dark:hidden">
                              <EditIcon />
                            </div>
                            <div className="hidden dark:block">
                              <EditIconDark />
                            </div>
                          </div>
                          {/* <EditIcon /> */}
                        </button>
                      </div>

                      {/* Temp Field */}
                      <div className="flex flex-row  mb-4 justify-between">
                        <div className="w-[20%]">
                          {todayTempIsLoading ? (
                            <>
                              <Loader />
                            </>
                          ) : (
                            <>
                              <label className="block text-sm text-start font-medium mb-1 text-textColorGray">
                                {translate('operation.temp')}
                              </label>

                              <ReusableSelect<ITemperature>
                                options={(tempList || []).sort(
                                  (a, b) => a.temperature - b.temperature,
                                )}
                                className={`border border-customBorder-border rounded p-2 text-sm w-full
                           bg-backgroundColor-darkThemeColor text-text-primary
                            ${
                              !isEditing ? 'pointer-events-none opacity-50' : ''
                            }`}
                                getOptionLabel={(option: ITemperature) =>
                                  `${option.temperature}°C`
                                }
                                getOptionValue={(option: ITemperature) =>
                                  option.temperatureId
                                }
                                onChange={(selectedValue: ITemperature) => {
                                  setSelectedTemperature(selectedValue);
                                  setTemp(selectedValue.temperatureId);
                                  const data = {
                                    temp1: selectedValue.temperatureId,
                                    ownerId: selectedLocation.OwnerId,
                                    toDate: encodeDateForUrl(selectedDate),
                                  };
                                  addTemperature(data);
                                }}
                                value={temp || todayTemp || undefined}
                                placeholder="Select Temp2"
                                isDisabled={!isEditing}
                              />
                            </>
                          )}
                        </div>
                        <div className="w-[70%]">
                          <label className="block text-textColorGray text-sm text-start font-medium mb-1">
                            {translate('operation.pic')}
                          </label>
                          <div className="flex items-center space-x-2">
                            <ReusableSelect<IDutyManager>
                              options={apiResponse?.picManager || []}
                              className={`w-full  bg-backgroundColor-darkThemeColor text-text-primary border border-customBorder-border rounded p-2 text-sm ${
                                !isEditing
                                  ? 'pointer-events-none opacity-50'
                                  : ''
                              }`}
                              getOptionLabel={(option) => {
                                const contact = [
                                  '',
                                  'null',
                                  'undefined',
                                  null,
                                  undefined,
                                ].includes(option?.staffContact)
                                  ? '--'
                                  : option.staffContact;

                                return `${option.staffName ?? '--'} ${contact}`;
                              }}
                              getOptionValue={(option) => option.staffId}
                              onChange={handleDutyPicChange}
                              placeholder="Select Duty Manager"
                              value={selectedPic}
                              isDisabled={!isEditing} // Disable when not in edit mode
                            />
                          </div>
                        </div>
                      </div>

                      {/* PIC Field */}
                    </div>
                  </div>
                )}

                {isPilotLoading || isPilotFetching ? (
                  <div className="flex justify-center align-middle">
                    <Loader />
                  </div>
                ) : staffAllocation && staffAllocation.length > 0 ? (
                  <CrewPilotDetailsCard
                    onOperationStaffIdChange={handleOperationStaffIdChange}
                    openModal={openModal}
                    crewList={staffAllocation}
                    onStaffChange={() => handleStaffChange('pilot')}
                  />
                ) : (
                  <div className="text-center text-textColorGray p-4">
                    {translate('operation.dataIsNotAvailable')}
                  </div>
                )}

                {activeModal === 'PilotForm' && crewDetails && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-2">
                    <PilotForm
                      balloons={apiResponse?.balloonList || []}
                      heading="Edit Pilots Details"
                      closeModal={closeModal}
                      crewVehicleList={apiResponse?.crewVehicleList || []}
                      operationStaffId={operationStaffId}
                      initialValues={crewDetails}
                      onStaffChange={() => handleStaffChange('pilot')}
                      staffAllocation={staffAllocation || null}
                      date={selectedDate}
                    />
                  </div>
                )}
              </Accordion>

              {/* Crew Allocation */}

              <CrewComponent
                routes={apiResponse?.routeList || []}
                buses={apiResponse?.busList || []}
                balloons={apiResponse?.balloonList || []}
                date={selectedDate}
              />
              <div className={`relative ${bgColor} rounded`}>
                <GeneralComment
                  comments={[]}
                  date={selectedDate}
                  closeModal={closeModal}
                />
              </div>
              <OperationCheckListComponent date={selectedDate} />
              {/* Weather and travel status */}
              <WeatherAndTravelStatus
                bgColor={bgColor}
                ownerId={selectedLocation?.OwnerId}
                selectedDate={selectedDate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopOperations;
